export default "__VITE_ASSET__DC_QEkO___"